---
title: Winter Field Day 2025
date: 2025-01-25
endDate: 2025-01-26
location: 5168 Robinson Park Rd, Moscow, ID 83843
coordinates: 46.75706684625334, -116.9972685225216
description: Join us for Winter Field Day 2025! Test your emergency communication skills in winter conditions.
published: true
---

# Winter Field Day 2025

Join the Do Something Amateur Radio Club for Winter Field Day 2025! This event demonstrates ham radio's ability to work reliably under any conditions from any location.

## Event Details

- **Date**: January 25-26, 2025
- **Time**: 11:00 AM PST Saturday to 11:00 AM PST Sunday
- **Location**: <a href="https://maps.app.goo.gl/uqBRfTBmekTuyZqeA" target="_blank" rel="noopener noreferrer">2370 N Polk Ext, Moscow, ID 83843</a>

<div class="mb-8">
<iframe title="Map of Winter Field Day location - 2370 N Polk Ext, Moscow, ID" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2733.397193161824!2d-116.9972685225216!3d46.75706684625334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x549f89eb009fd62f%3A0x8b1579fd92ae333c!2s2370%20N%20Polk%20Ext%2C%20Moscow%2C%20ID%2083843!5e0!3m2!1sen!2sus!4v1735864037788!5m2!1sen!2sus" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>

## About Winter Field Day

Winter Field Day is a communications exercise. Like ARRL Field Day in June, the purpose is to contact as many stations as possible during the 24-hour period. The difference? Winter Field Day occurs at a time when emergency communications are often more necessary - in the winter.

### Event Goals
- Test emergency communications capabilities in winter conditions
- Enhance operator skills
- Demonstrate ham radio's reliability in adverse conditions
- Build camaraderie within the amateur radio community

## What to Bring
- Warm clothing and winter gear
- Hand warmers
- Thermos for hot beverages
- Snacks and food
- Your radio equipment if you have it (not required)

## Resources
- <a href="https://winterfieldday.org/" target="_blank" rel="noopener noreferrer">Official Winter Field Day Website</a>
- <a href="https://winterfieldday.org/sop.php" target="_blank" rel="noopener noreferrer">Winter Field Day Rules</a>
- <a href="https://winterfieldday.org/resources.php" target="_blank" rel="noopener noreferrer">WFD FAQ</a>

## Club Station Details
- Club Call Sign: K7DSC
- ARRL Section: ID
- Operating Category: TBD

## Getting Involved
Whether you're a licensed amateur radio operator or just interested in learning more about ham radio, you're welcome to join us! This is a great opportunity to:
- Learn about emergency communications
- Operate various radio equipment
- Meet fellow ham radio enthusiasts
- Experience winter field operations

For more information or to RSVP, please [contact us](/contact) or join our <a href="https://discord.gg/432vsVAuwZ" target="_blank" rel="noopener noreferrer">Discord server</a>.
